export default class PushMessagesCreateRequest {
    constructor(locale, supportedLocales) {        
        this.translations = [];
        supportedLocales.forEach(element => {
            this.translations[element] = {
                title : '',        
                description : ''        
            };
        });

        this.publishDate = null;
        this.selectedProfessionalStatuses = [];
        this.selectedAge = [];
        this.selectedLivingPlaces = [];
        this.sendNotificationToAll = true;
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
            to.title = from.title;
        } else {
            to = new PushMessagesCreateRequest();
        }
    }

    static copy(from) {
        const to = new PushMessagesCreateRequest();
        PushMessagesCreateRequest.assign(from, to);
        return to;
    }
}
